// removed by extract-text-webpack-plugin
module.exports = {"svg":"StepGroup__svg","largeCircle":"StepGroup__largeCircle","smallCircle":"StepGroup__smallCircle","active":"StepGroup__active","activeRing":"StepGroup__activeRing","completeRing":"StepGroup__completeRing","pending":"StepGroup__pending","disabled":"StepGroup__disabled","complete":"StepGroup__complete","error":"StepGroup__error","errorRing":"StepGroup__errorRing","nameText":"StepGroup__nameText","activeText":"StepGroup__activeText"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StepGroup/StepGroup.scss
// module id = ./src/components/StepGroup/StepGroup.scss
// module chunks = 2